<template>
  <v-dialog v-model="open" persistent :max-width="maxWidth">

    <v-card>

      <v-card-title>Add Number/s</v-card-title>

      <v-tabs v-model="tab">
        <v-tab v-for="(name, key) in tabType" v-bind:key="name" :disabled="addNumberLoading" class="text-capitalize" @click="currentTabType = key">{{name}}</v-tab>
      </v-tabs>

      <Geo :currentTabType="currentTabType" :addNumberLoading="addNumberLoading" :updateMaxWidth="updateMaxWidth" :updateNumbersToSend="updateNumbersToSend" :displayResetBtn="displayResetBtn"/>

      <NonGeo :currentTabType="currentTabType" :addNumberLoading="addNumberLoading" :updateMaxWidth="updateMaxWidth" :updateNumbersToSend="updateNumbersToSend" :displayResetBtn="displayResetBtn"/>

      <v-divider />

      <v-card-actions>
        <v-btn color="warning" small outlined @click="resetForm" v-if="isShowResetBtn">RESET</v-btn>

        <v-spacer></v-spacer>

        <v-btn color="primary" small :disabled="numbersToSend.length===0||addNumberLoading" :loading="addNumberLoading" @click="checkAdditionalNumberCharges">Add Number{{(numbersToSend.length===1)?'':'s'}}</v-btn>
        <v-btn color="primary" small outlined @click="closeDialog();">CLOSE</v-btn>

      </v-card-actions>

    </v-card>

    <AdditionalNumberCharges :dialogOpen="addNumberChargesOpen" @close-dialog="addNumberChargesOpen=false;" @confirmed="triggerAddNumber" />

  </v-dialog>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";

  import AdditionalNumberCharges from '../AdditionalNumberCharges';
  import Geo from './Geo';
  import NonGeo from './NonGeo';

  export default {
    components: { AdditionalNumberCharges,Geo,NonGeo },
    
    props: {
      open: {
        type: Boolean
      } 
    },

    data() {
      return {
        maxWidth: 0,
        tabType: {
          geo: 'Geo',
          nonGeo: 'Non-Geo',
        },
        tab: null,
        currentTabType: 'geo',
        numbersToSend: [],
        isShowResetBtn: false,
        addNumberLoading: false,
        addNumberChargesOpen: false,
      };
    },

    computed: {
      ...mapState('products', ['productNumbers']),
      ...mapGetters('products', ['getCurrentProduct']),
    },

    methods: {

      ...mapActions('numbers', ['addNumbers']),

      updateMaxWidth(maxWidth) {
        this.maxWidth = maxWidth;
      },

      updateNumbersToSend(array) {
        this.numbersToSend = array;
      },

      displayResetBtn(bool) {
        this.isShowResetBtn = bool;
      },

      async checkAdditionalNumberCharges() {
        let numbers = this.numbersToSend;
        if(this.productNumbers.length>0||numbers.length>1){
          this.addNumberChargesOpen = true;
        }else{
          this.triggerAddNumber();
        }
      },

      async triggerAddNumber() {
        let numbers = this.numbersToSend;
        this.addNumberLoading = true;
        await this.addNumbers({p_id: this.getCurrentProduct.id, nums: numbers});
        this.$emit('numberAdded');
        this.addNumberLoading = false;
        this.closeDialog();
      },

      resetForm() {
        let key;
        switch(this.currentTabType) {
          case 'geo':
            key = 'ADD_NUMBERS_DIALOG_GEO_RESET';
            break;
          case 'nonGeo':
            key = 'ADD_NUMBERS_DIALOG_NON_GEO_RESET';
            break;
        }
        if (key) {
          this.$root.$emit(key);
        }
      },

      resetDialog() {
        this.$root.$emit('ADD_NUMBERS_DIALOG_GEO_RESET');
        this.$root.$emit('ADD_NUMBERS_DIALOG_NON_GEO_RESET');
        this.$root.$emit('ADD_NUMBERS_DIALOG_NON_GEO_RESET_VALIDATION');
        this.tab = null;
        this.currentTabType = 'geo';
      },

      closeDialog() {
        this.resetDialog();
        this.$emit('closeDialog');
      },    
    },
  };
</script>

<style lang="scss" scoped>
  .areacodecity-icon {
    cursor: pointer;
  }
</style>
